/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Tab, Nav } from "react-bootstrap";
import { Trans } from "react-i18next";
import OrganizationCard from "./OrganizationCard";

class FordOrganization extends Component {
  state = {
    currentTab: "#fordtrucks",
  };

  render() {
    return (
      <section className="profilArea my-3">
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Kurumsal">10026</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Ford Organizasyon">10040</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Ford Organizasyon">10040</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <Tab.Container
                id="nav-tab"
                defaultActiveKey="#general"
                activeKey={this.state.currentTab}
              >
                <nav className="scrollNav">
                  <Nav variant="tabs" role="tablist" className="fordOrgNav">
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() =>
                          this.setState({ currentTab: "#fordtrucks" })
                        }
                        eventKey="#fordtrucks"
                      >
                        <span className="iconmford fo-icon-local-shipping"></span>{" "}
                        <Trans desc="FordTrucks">10190</Trans>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </nav>
                <Tab.Content>
                  <Tab.Pane eventKey="#fordtrucks">
                    <div className="row">
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>efkangucvar_fullname</Trans>,
                          title: <Trans>efkangucvar_title</Trans>,
                          profileImage: "img/deryagulunay.jpg",
                          phone: "+902165647263",
                          formattedPhone: "+90 216 564 72 63",
                          mail: "dgulunay@ford.com.tr",
                          responsibilities: [
                            <Trans>efkangucvar_responsibility1</Trans>,
                            <Trans>efkangucvar_responsibility2</Trans>,
                            <Trans>efkangucvar_responsibility3</Trans>,
                            <Trans>efkangucvar_responsibility4</Trans>,
                            <Trans>efkangucvar_responsibility5</Trans>,
                            <Trans>efkangucvar_responsibility6</Trans>,
                            <Trans>efkangucvar_responsibility7</Trans>,
                            <Trans>efkangucvar_responsibility8</Trans>,
                            <Trans>efkangucvar_responsibility9</Trans>,
                          ],
                        }}
                      />
                    </div>
                    <div className="row">
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>serkangazel_fullname</Trans>,
                          title: <Trans>serkangazel_title</Trans>,
                          profileImage: "img/ford-personel-serkan-gazel.jpg",
                          phone: "+902165647361",
                          formattedPhone: "+90 216 564 73 61",
                          mail: "sgazel@ford.com.tr",
                          responsibilities: [
                            <Trans>serkangazel_responsibility1</Trans>,
                            <Trans>serkangazel_responsibility2</Trans>,
                            <Trans>serkangazel_responsibility3</Trans>,
                            <Trans>serkangazel_responsibility4</Trans>,
                          ],
                        }}
                      />

                      <OrganizationCard
                        employee={{
                          fullname: <Trans>halitekiz_fullname</Trans>,
                          title: <Trans>halitekiz_title</Trans>,
                          profileImage:
                            "img/ford-personel-halit-emrah-ekiz.jpg",
                          phone: "+902165647473",
                          formattedPhone: "+90 216 564 74 73",
                          mail: "eekiz1@ford.com.tr",
                          responsibilities: [
                            <Trans>halitekiz_responsibility1</Trans>,
                            <Trans>halitekiz_responsibility2</Trans>,
                            <Trans>halitekiz_responsibility3</Trans>,
                            <Trans>halitekiz_responsibility4</Trans>,
                            <Trans>halitekiz_responsibility5</Trans>,
                            <Trans>halitekiz_responsibility6</Trans>,
                          ],
                        }}
                      />

                      <OrganizationCard
                        employee={{
                          fullname: <Trans>ozanboray_fullname</Trans>,
                          title: <Trans>ozanboray_title</Trans>,
                          profileImage: "img/ford-personel-volkan_peren.jpg",
                          phone: "+902165647731",
                          formattedPhone: "+90 216 564 77 31",
                          mail: "vperen@ford.com.tr",
                          responsibilities: [
                            <Trans>ozanboray_responsibility1</Trans>,
                            <Trans>ozanboray_responsibility2</Trans>,
                            <Trans>ozanboray_responsibility3</Trans>,
                            <Trans>ozanboray_responsibility4</Trans>,
                          ],
                        }}
                      />
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>

              {/* <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-profile"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                >
                  
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-contact"
                  role="tabpanel"
                  aria-labelledby="nav-contact-tab"
                >
                  
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FordOrganization;
